import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: () => ({
    about: null,
    personalPhotos: [],
    allPhotosLoaded: false,
    noResult: false,
    meta: null,
    page: 1,
  }),
  actions,
  getters,
  mutations,
};
